const mainDomain = "https://api.the3dcreator.com";
const imageDomain = "https://api.the3dcreator.com";
// const mainDomain = "http://localhost:5050"
// const imageDomain = "http://localhost:5050";

const Constant = {
    mainDomain,
    imageDomain,

    getUrls:{
        getUser: mainDomain + "/user",
        getUserDetails: mainDomain + "/user/details",
        getAllCategories: mainDomain + "/category",
        getAllproducts: mainDomain + "/products",
        getBanners: mainDomain + "/banner",
        getAllTestimonials: mainDomain + "/testimonial",
        verifyPayment: mainDomain + "/order/payment/verify",
        getMyOrders: mainDomain + "/order/my-orders",
    },
    
    postUrls:{
        googleAuth: mainDomain + "/user/google-auth",
        register: mainDomain + "/user/create",
        updateMobile: mainDomain + "/user/update-mobile",
        login: mainDomain + "/user/login",
        getAllProductsList: mainDomain + "/products/list",
        getProductDetails: mainDomain + "/products/details",
        getSimilarProducts: mainDomain + "/products/similar",
        postEnquiry: mainDomain + "/enquiry/add",
        addLead: mainDomain + "/leads/create",
        addToCart: mainDomain + "/cart/create",
        getMyCartItems: mainDomain + "/cart",
        updateCartQty: mainDomain + "/cart/updateQty",
        removeCartItem: mainDomain + "/cart/remove",
        addAddress: mainDomain + "/address/create",
        getMyAddresses: mainDomain + "/address",
        deleteAddress: mainDomain + "/address/delete/",
        placeOrder: mainDomain + "/order/create",
        createOrder: mainDomain + "/order/create",
       
    }
    };

    export default Constant;
